import { api } from "@api/api";
import { Platform } from "@api/public/get/getPlatforms";

const deletePlatform = async (platformID: string) => {
  const { data } = await api.post<Platform>("/deletePlatform", { platformID });
  return data;
};

export default deletePlatform;
